import {
  signIn,
  confirmSignIn,
  resetPassword,
  confirmResetPassword,
  getCurrentUser,
} from "aws-amplify/auth";
import { signOut } from "aws-amplify/auth";
import { resetAuthBootstrap } from "@/services/authSession.js";
export const cognitoAPIs = {
  data() {
    return {
      loading: false,
      signIn: {
        EmailID: "",
        OTP: "",
      },
    };
  },
  methods: {
    async getCurrentUsermethod() {
      try {
        const { username, userId, signInDetails } = await getCurrentUser();
        signInDetails.username = username;
        signInDetails.userId = userId;
        return {
          status: "SUCCESS",
          data: { ...signInDetails },
        };
      } catch (error) {
        return {
          status: "ERROR",
          data: error.message,
        };
      }
    },
    async validateSignIn() {
      let result = await this.$refs.formSignIn.validate();
      if (result.valid) {
        this.loading = true;
        this.mainSignInMethod();
      }
    },
    // One-time migration path: a user who doesn't exist here yet fails the
    // default SRP attempt (Cognito never sees the password under SRP, so
    // there's nothing for a backend migration trigger to verify). Retrying
    // with USER_PASSWORD_AUTH sends the password explicitly, which is what
    // the UserMigration trigger needs to check against the legacy pool and
    // provision the account here. Already-migrated/native users always
    // succeed on the first attempt and never hit this retry.
    async attemptSignIn(credentials) {
      try {
        return await signIn(credentials);
      } catch (error) {
        if (
          error.name === "UserNotFoundException" ||
          error.name === "NotAuthorizedException"
        ) {
          return await signIn({
            ...credentials,
            options: { authFlowType: "USER_PASSWORD_AUTH" },
          });
        }
        throw error;
      }
    },
    async mainSignInMethod() {
      this.AddRememberMe();
      try {
        const user = await this.attemptSignIn({
          username: this.Login.EmailID.trim(),
          password: this.Login.Password,
        });
        this.user = user;
        if (user.isSignedIn == true && user.nextStep.signInStep == "DONE") {
          this.$store.commit("SET_USEREMAIL", this.Login.EmailID);
          resetAuthBootstrap();
          this.ActivateMethod();
        } else {
          if (
            user.nextStep.signInStep ==
            "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
          ) {
            this.loginStepper = 2;
          } else {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "error",
              Top: true,
              SnackbarText:
                "Something went wrong!! Please try after sometime!!",
            };
          }
        }
        this.loading = false;
      } catch (error) {
        if (error.message == "There is already a signed in user.") {
          await signOut();
          return this.mainSignInMethod();
        } else {
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: error.message,
          };
        }
      }
    },
    async ValidateConfirmPasswordForm() {
      let result = await this.$refs.formCP.validate();
      if (result.valid) {
        if (this.Password.NewPassword == this.Password.ConfirmPassword) {
          this.ConfirmPassword();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "Password does not match",
          };
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Fields marked with asterisks(*) are mandatory",
        };
      }
    },
    async ConfirmPassword() {
      try {
        this.loading = true;
        let result = await confirmSignIn({
          challengeResponse: this.Password.NewPassword,
        });
        if (result.isSignedIn && result.nextStep.signInStep == "DONE") {
          this.$store.commit("SET_USEREMAIL", this.signIn.EmailID);
          resetAuthBootstrap();
          this.ActivateMethod();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "Something went wrong!! Please try after sometime!!",
          };
        }
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    async ValidateResetPassword() {
      let result = await this.$refs.formResetPasswordSendOTP.validate();
      if (result.valid) {
        this.loading = true;
        this.ResetPasswordMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Please Enter Registered Email",
        };
      }
    },
    async ResetPasswordMethod() {
      try {
        let result = await resetPassword({
          username: this.ResetPassword.EmailID,
        });
        if (
          result.isPasswordReset == false &&
          result.nextStep.resetPasswordStep ==
            "CONFIRM_RESET_PASSWORD_WITH_CODE"
        ) {
          this.loginStepper = 4;
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "Something went wrong!! Please try after sometime!!",
          };
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    async ValidateResetPasswordFinalMethod() {
      let result = await this.$refs.formConfirmOTP.validate();
      if (result.valid) {
        if (this.ResetPassword.Password == this.ResetPassword.ConfirmPassword) {
          this.loading = true;
          this.ConfirmOTPMethod();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "Password does not match!!",
          };
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Fields marked with asterisk(*) are mandatory!!",
        };
      }
    },
    async ConfirmOTPMethod() {
      try {
        await confirmResetPassword({
          username: this.ResetPassword.EmailID,
          confirmationCode: this.ResetPassword.ActivationCode,
          newPassword: this.ResetPassword.Password,
        });
        this.loginStepper = 1;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: "Password updated successfully!!",
        };
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.loginStepper = 3;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    ActivateMethod() {
      setTimeout(() => this.$router.push("/LandingPage"), 500);
    },
  },
};
